export default "__VITE_ASSET__Zron0kZi__"